// Copyright © 2021 Move Closer
export { IReactionsService } from '@modules/services/reactions';
export const ReactionsServiceType = Symbol.for('IReactionsService');
